import { IDashboardHomeCardMetricKey } from '~/src/dash/api/dashboards/home';
import { IDashboardChartMetric } from '~/src/dash/components/charts/common';
import { TimeRange } from '~/src/dash/utils/dateTimeRanges';
import {
  bidErrorsMetrics,
  clearedActiveFilters,
  IActiveFilters,
  IDashboardLiveCards,
  IDashboardSubChart,
  keyLatencyMetrics,
} from '~/src/dash/views/dashboards/DashboardHome/common/common';

export interface IDashboardLiveConfig {
  defaultState: {
    activeFilters: IActiveFilters;
    timeRange: TimeRange;
    displayedMetricKeys: IDashboardHomeCardMetricKey[];
    activeChartMetrics: IDashboardChartMetric[];
  };
  orderedFilterKeys: string[];
  cards: IDashboardLiveCards;
  subCharts: IDashboardSubChart[];
  chartSyncID: string;
}

// IMPORTANT: PLEASE READ THE README BEFORE EDITING -> https://publica-project.atlassian.net/wiki/x/DQDXpQ
export const dashboardLiveConfig: IDashboardLiveConfig = {
  chartSyncID: 'dashboard_live',
  defaultState: {
    activeFilters: clearedActiveFilters,
    timeRange: '1 Hour By Minute',
    displayedMetricKeys: [
      'Revenue',
      'WinningBids',
      'Impressions',
      'CPM',
      'EndpointRequests',
      'RenderRate',
    ],
    activeChartMetrics: [
      {
        key: 'Revenue',
        label: 'Revenue',
        chartColorIndex: 0,
        chartType: 'bar',
        valueType: 'currency',
        yScale: 'base',
      },
    ],
  },
  orderedFilterKeys: [
    'Filtered Demand Sources',
    'Bidders',
    'Bidder Groups',
    'Channels',
    'Channel Groups',
    'Routes',
    'Destinations',
    'Device Types',
    'Outbound Deals', // custom case only for live dash
  ],
  cards: {
    groupings: {
      noDemandSelected: [
        'Revenue',
        'WinningBids',
        'Impressions',
        'CPM',
        'EndpointRequests',
        'RenderRate',
        'CPMPerSecond',
        'EndpointRequestsECPM',
        'Auctions',
        'PodFillRate',
        'PodClearRate',
        'PaidPodClearRate',
        'BidRequests',
        'BidResponses',
        'BidResponseRate',
        'BidTimeoutRate',
        'BidWinRate',
        'FillRate',
      ],
      demandSelected: [
        'Revenue',
        'WinningBids',
        'Impressions',
        'CPM',
        'BidResponses',
        'RenderRate',
        'CPMPerSecond',
        'BidRequests',
        'BidResponseRate',
        'BidTimeoutRate',
        'BidWinRate',
      ],
    },
    superUserGroupings: {
      noDemandSelected: ['BidSaverTrueLift', 'BidSaverImpressions', 'BidSaverWinningBids'],
      demandSelected: ['BidSaverTrueLift', 'BidSaverImpressions', 'BidSaverWinningBids'],
    },
  },
  subCharts: [
    {
      title: 'Key Latencies (ms)',
      metrics: keyLatencyMetrics,
      orderedMetricKeys: ['EndpointLatency', 'AuctionLatency', 'BidderLatency'],
    },
    {
      title: 'Bid Errors',
      metrics: bidErrorsMetrics,
      orderedMetricKeys: ['BidErrors', 'BidTimeouts'],
    },
  ],
};

export const getDashboardLiveConfig = (isSuperUser: boolean): IDashboardLiveConfig => {
  if (isSuperUser) {
    // NoDemand
    (dashboardLiveConfig?.cards?.superUserGroupings?.noDemandSelected || []).forEach(
      (superUserGrouping: string) => {
        (dashboardLiveConfig?.cards?.groupings?.noDemandSelected || []).push(superUserGrouping);
      },
    );
    // Demand
    (dashboardLiveConfig?.cards?.superUserGroupings?.demandSelected || []).forEach(
      (superUserGrouping: string) => {
        (dashboardLiveConfig?.cards?.groupings?.demandSelected || []).push(superUserGrouping);
      },
    );
  }
  return dashboardLiveConfig;
};
